import React, { useState, useEffect } from "react";
import { motion } from 'framer-motion'
import { pageTransitions, transitionDuration } from "../../../../../Util/PageTransitions";
import "./Sponsors.css";
import AddSponsor from "./AddSponsor";
import SponsorItem from "./SponsorItem";
import WarningDialogue from "../../../../../Util/WarningDialogue";
import axiosApi from '../../../../../core/interceptor/interceptor';
import { config } from "../../../../../config";

export default function Sponsors(props) {
  const [sponsors, setSponsors] = useState([]);
  const [viewItemDetails, setViewItemDetails] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [isNewItem, setIsNewItem] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const setAddEditItem = (itemDetails = {
    image: '',
    name: '',
    hyper_link: '',
    type: '',
  }, newItem = isNewItem) => {
    setViewItemDetails(true);
    setSelectedItem(itemDetails);
    setIsNewItem(newItem);
  }

  const getSponsors = () => {
    axiosApi.get(`${config.apiUrl}/sponsor`)
    .then((res) => {
      setSponsors(res?.data?.data);
    })
  }

  useEffect(() => {
    getSponsors();
  }, []);

  const close = () => {
    setViewItemDetails(false);
  }
  const refresh = (flag) => {
    if (flag) {
      getSponsors();
    }
  }

  return <>
    {viewItemDetails && (
      <AddSponsor
        itemDetails={selectedItem}
        isNewItem={isNewItem}
        onClose={close}
        isAddOrEdit={refresh}
      />
    )}
    <motion.div
      className="adminMenuContainer addMenulist"
      initial={pageTransitions.initial}
      animate={pageTransitions.in}
      exit={pageTransitions.out}
      transition={{ duration: transitionDuration }}
    >
      <div className="content-wrapper menu-wrapper">
        <div className="heading-wrapper">
          <div className="left">
            <h1 className="heading">
              Advertisements
            </h1>
          </div>
        </div>
        <div className='admin-menu-section-wrapper'>
          <div>
            <div className="adminMenuSectionContainer">
          <div className={`adminMenuItemsContainer adminMenuItemsContainer-website  home-slider-grid`}>
            { sponsors && sponsors.length ? sponsors?.map((value, index) => (
              <SponsorItem itemDetails={value} isItemDelete={refresh} key={index} setItemDisplay={() => setAddEditItem({id: value?.id, image: value.image, name: value?.name, hyper_link: value?.hyper_link, type: value?.type}, false)} viewItemDetails={props.viewItemDetails} />
            )) : ''}
            {<div className='addnew-item-block' onMouseDown={() => setAddEditItem(undefined, true)}>
              <div className="box-content-item">
                <div className="addsign"><span>+</span></div>
                <h2 className='adminMenuItemTitle'>Add New Item</h2>
                <p className='adminMenuItemDescription'>Add a new item to Advertisement</p>
              </div>
            </div>}
          </div>
          </div>
          </div>
        </div >
      </div>

    </motion.div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}